export enum IFontTypes {
	primaryRegular = 'primaryRegular',
	primaryMedium = 'primaryMedium',
	primaryHeavy = 'primaryHeavy',
	secondaryRegular = 'secondaryRegular',
	mainButton = 'mainButton',
}

interface IFont {
	primaryRegular: string[]
	primaryMedium: string[]
	primaryHeavy: string[]
	secondaryRegular: string[]
	mainButton: string[]
}

const fonts: IFont = {
	primaryRegular: ['npprimarymedium', 'sans-serif'],
	primaryMedium: ['npprimarysemibold', 'sans-serif'],
	primaryHeavy: ['npprimaryextrabold', 'sans-serif'],
	secondaryRegular: ['Bubblegum Sans', 'cursive'],
	mainButton: ['npprimarymedium', 'sans-serif'],
}

export const addFont = (name: string, family: IFontTypes) => {
	const fontFamily = fonts[family] || []
	const fontIndex = fontFamily.findIndex((fontName) => fontName === name)
	if (fontIndex === -1) {
		fontFamily.unshift(name)
	}
}

const getFont = (type: keyof IFont) => {
	return fonts[type].join(',')
}

export default getFont
